/* eslint-disable no-control-regex */
import * as Yup from 'yup';
import { phoneCountryCode, phoneNumber, gender } from 'validation';

export default Yup.object({
  beneficiary: Yup.string()
    .test('test-beneficiary', 'Name containing numbers is not valid', (value) =>
      /^([^0-9]*)$/g.test(value)
    )
    .test('isExtendedASCII', 'Name contains invalid characters', (value) =>
      /^([\x00-\xFF]*)$/g.test(value)
    )
    .min(2, 'Minimum length is 2')
    .max(60, 'Maximum length is 60')
    .required('Required')
}).shape({ gender, phoneCountryCode, phoneNumber });
